import React from 'react'

function ProfileSection(){
 
  return (
    <div tabIndex='1' className='profile-box'>
    <div className='profile-img-box'>
        <img src='final1.jpg' alt='Profile of Rudra Karmakar'/>
    </div>
    <div className='profile-text'>
          <h4>A WEB DEVELOPER</h4>  
          <h1>Rudra Karmakar</h1>
          <p>I am a Web Developer based in Medinipur.</p>
    </div>
    </div>
  )
}

export default ProfileSection;
